module.exports = __webpack_public_path__ + "static/media/5-audio.cd36830.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/5-audio.wav
// module id = chp4
// module chunks = 0